import React from 'react';
import { Provider } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import shippingRegion from '../../../../../state/shipping-region/reducer';
import initData from 'tradera/legacy/static/packages/init-data';
import language, {
    initialize as initLanguage
} from '../../../../../state/language/reducer';
import { initializeFromInitData as initShippingRegion } from 'tradera/state/shipping-region/actions';
import { reducer as environment } from '../../../../../state/environment/reducer';
import { initEnvironment } from 'tradera/state/environment/actions';
import type { InitData } from 'tradera/state/init-data/types';
import type { AppDispatch } from 'tradera/state/configure-store';

const initializeStore = () => {
    const isProd =
        typeof process === 'object' && process.env?.NODE_ENV === 'production';

    return configureStore({
        reducer: combineReducers({
            environment,
            language,
            shippingRegion
        }),
        devTools: !isProd || window.location.search.includes('debug-redux'),
        preloadedState: {}
    });
};

const initializeState = (initData: InitData) => (dispatch: AppDispatch) => {
    dispatch(initLanguage(initData));
    dispatch(initShippingRegion(initData));
    dispatch(initEnvironment(initData));
};

const store = initializeStore();
initializeState(initData)(store.dispatch);

/**
 * A Redux Provider with a minimal state.
 * @param {*} props
 * @returns
 */
export const LoginStateProvider = ({ children }: React.PropsWithChildren) => (
    <Provider store={store}>{children}</Provider>
);
